<template>
  <a-modal
      class="anchor-page"
      centered
      :title="`巨量小程序锚点列表 (${model.name})`"
      :width="'85%'"
      :mask-closable="false"
      :visible="showAnchorForm"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="pullData" type="danger" icon="cloud" v-if="accessTo('pullAnchor')">手动拉取锚点</a-button>
          <a-button @click="createAnchor" type="primary" icon="plus" v-if="accessTo('createAnchor')">创建锚点</a-button>
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >

        <template slot="status" slot-scope="status">
          <a-tag color="green" v-if="status == 'AUDIT_SUCCESS'">审核通过</a-tag>
          <a-tag color="red" v-else-if="status == 'AUDIT_FAILD'">审核不通过</a-tag>
          <a-tag color="orange" v-else>审核中</a-tag>
       </template>

        </a-table>
      </a-layout-content>
    </a-layout>


    <create-anchor-form
    v-if="showCreateForm"
    :showCreateForm.sync="showCreateForm"
    :anchorModel="anchorModel"
    @success="refresh"
    />

  </a-modal>

</template>

<style lang="less" scoped>
@import 'Anchor';
</style>

<script>
import Anchor from './Anchor'

export default Anchor
</script>

